import React, { useState } from "react";
import { FileDoneOutlined } from "@ant-design/icons";
import toast, { Toaster } from "react-hot-toast";

import axios from "axios";
import { message } from "antd";

const ShareContractDetail = ({ contractData, token }) => {
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const PUBLIC_API_URL = process.env.REACT_APP_API_BASE_URL;
  const PUBLIC_COPY_URL = process.env.REACT_APP_PUBLIC_COPY_URL;

  const copyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success("Copied contract URL to clipboard!", {
          duration: 7000,
          style: {
            border: "1px solid #4BB543",
            padding: "16px",
            color: "#4BB543",
            background: "#E8F5E9",
          },
          iconTheme: {
            primary: "#4BB543",
            secondary: "#FFFAEE",
          },
        });
      })
      .catch((err) => {
        toast.error("Failed to copy URL", {
          style: {
            border: "1px solid #FF0000",
            padding: "16px",
            color: "#FF0000",
            background: "#FFEBEE",
          },
          iconTheme: {
            primary: "#FF0000",
            secondary: "#FFFAEE",
          },
        });
      });
  };

  const handleShareClick = async () => {
    // First copy the URL to clipboard
    const verificationUrl = `${PUBLIC_COPY_URL}?token=${token}`;
    copyToClipboard(verificationUrl);

    if (!emailSent) {
      await sendEmailContract();
    }
  };

  const sendEmailContract = async () => {
    if (!token || !contractData) {
      toast.error("Missing contract data or token", {
        style: {
          border: "1px solid #FF0000",
          padding: "16px",
          color: "#FF0000",
          background: "#FFEBEE",
        },
        iconTheme: {
          primary: "#FF0000",
          secondary: "#FFFAEE",
        },
      });
    }

    try {
      setLoading(true);
      const payload = {
        contract_id: contractData.contract_details.contract_id,
      };

      const emailResponse = await axios.post(
        `${PUBLIC_API_URL}contract/send-email`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (emailResponse.data.meta.code === 200) {
        toast.success(
          emailResponse.data.data.message || "Contract shared successfully!",
          {
            duration: 4000,
            style: {
              border: "1px solid #4BB543",
              padding: "16px",
              color: "#4BB543",
              background: "#E8F5E9",
            },
            iconTheme: {
              primary: "#4BB543",
              secondary: "#FFFAEE",
            },
          }
        );
        // Copy verification URL to clipboard
        if (emailResponse.data.data.verification_url) {
          copyToClipboard(emailResponse.data.data.verification_url);
        }
        setEmailSent(true);
      } else {
        throw new Error(
          emailResponse.data.meta.message || "Failed to send email"
        );
      }
    } catch (error) {
      message.error(
        error.response?.data?.message ||
          error.message ||
          "Failed to share contract. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="shareContract_main">
      <div className="shareContractDetail">
        <div className="shareContract_wrapper">
          <div className="confirmationMsg">
            <p>Thanks for submitting your information! </p>
          </div>

          <div className="shareContract_content">
            <span className="shareContract_icon">
              <FileDoneOutlined id="icon" />
            </span>
            <div className="shareContract_text">
              <h3>Contract</h3>
              <p>
                The contract will be generated once <b>the other party</b> has
                also filled out their details.
              </p>
            </div>
          </div>

          <div className="shareContract_content">
            <span className="shareContract_icon">
              <p id="electricity-icon">🗲</p>
            </span>
            <div className="shareContract_text">
              <h3>Matching Score</h3>
              <p>
                You'll receive an email with a matching score, showing how
                closely your expectations align, especially regarding the
                condition and rules of the home.
              </p>
            </div>
          </div>
          <div
            className={`shareContractBtn_wrapper ${
              loading ? "shareContractBtn_wrapper_disable" : ""
            }`}
          >
            <button
              type="submit"
              className="shareContractBtn"
              onClick={handleShareClick}
              disabled={loading}
            >
              {loading ? (
                <>
                  {" "}
                  Sending email &nbsp; <i className="fa fa-spinner fa-spin"></i>
                </>
              ) : emailSent ? (
                "Link Copied"
              ) : (
                <>
                  Share with{" "}
                  {contractData.contract_details.role === "host"
                    ? "Guest"
                    : "Host"}{" "}
                  <img
                    id="shareContract-email-icon"
                    src="assets/img/arrow-left-to-arc-icon.png"
                    alt="share contract"
                  />
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareContractDetail;
